import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Countdown = ({ targetDate, language }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(targetDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const labels = {
    fr: { days: 'Jours', hours: 'Heures', minutes: 'Minutes', seconds: 'Secondes' },
    en: { days: 'Days', hours: 'Hours', minutes: 'Minutes', seconds: 'Seconds' }
  };

  return (
    <div className="flex justify-center gap-4 md:gap-8 flex-wrap">
      {Object.entries(timeLeft).map(([unit, value], index) => (
        <motion.div
          key={unit}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.08, duration: 0.4 }}
          className="relative group"
        >
          {/* Glow effect - Optimisé */}
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl blur-sm opacity-20 group-hover:opacity-40 transition duration-300"></div>
          
          {/* Card */}
          <div className="relative flex flex-col items-center bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md rounded-2xl p-6 md:p-8 min-w-[100px] md:min-w-[140px] border border-white/20 shadow-2xl">
            <motion.div
              key={value}
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="text-5xl md:text-7xl lg:text-8xl font-black bg-gradient-to-b from-white to-blue-200 bg-clip-text text-transparent mb-3"
            >
              {String(value).padStart(2, '0')}
            </motion.div>
            <div className="text-xs md:text-sm text-white/90 uppercase tracking-widest font-semibold">
              {labels[language][unit]}
            </div>
            
            {/* Decorative line */}
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-gradient-to-r from-transparent via-blue-400 to-transparent"></div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default Countdown;
